import React from "react";

const Aboutus = () => {
  const sectionStyle = {
    padding: "100px 20px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    background: "linear-gradient(135deg, #f5faff 0%, #e0f3ff 100%)",
    fontFamily: "'Poppins', sans-serif",
    flexWrap: "wrap",
    gap: "60px",
  };

  const leftStyle = {
    flex: "1",
    minWidth: "320px",
    maxWidth: "600px",
    textAlign: "left",
    animation: "fadeIn 1.2s ease-in-out",
  };

  const headingStyle = {
    fontSize: "42px",
    fontWeight: "800",
    color: "#002b5c",
    marginBottom: "20px",
    lineHeight: "1.3",
  };

  const highlight = {
    color: "#ffcb24",
  };

  const paragraphStyle = {
    fontSize: "18px",
    color: "#555",
    lineHeight: "1.8",
    marginBottom: "30px",
  };

  const pointsContainer = {
    display: "flex",
    flexDirection: "column",
    gap: "15px",
    marginBottom: "40px",
  };

  const point = {
    display: "flex",
    alignItems: "center",
    fontSize: "17px",
    color: "#333",
    fontWeight: "500",
  };

  const bullet = {
    width: "12px",
    height: "12px",
    background: "#ffcb24",
    borderRadius: "50%",
    marginRight: "15px",
  };

  const buttonStyle = {
    padding: "14px 35px",
    background: "#ffcb24",
    color: "#fff",
    fontSize: "17px",
    fontWeight: "600",
    border: "none",
    borderRadius: "30px",
    cursor: "pointer",
    transition: "transform 0.3s ease",
  };

  const rightStyle = {
    flex: "1",
    minWidth: "320px",
    maxWidth: "600px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    position: "relative",
  };

  const imageStyle = {
    width: "100%",
    maxWidth: "500px",
    borderRadius: "20px",
    boxShadow: "0 10px 30px rgba(0,0,0,0.1)",
    transform: "scale(1)",
    transition: "transform 0.4s ease",
  };

  const overlayCircle = {
    position: "absolute",
    top: "-40px",
    right: "-40px",
    width: "150px",
    height: "150px",
    borderRadius: "50%",
    background: "linear-gradient(135deg, #007bff 0%, #00d4ff 100%)",
    opacity: "0.2",
    zIndex: "-1",
  };

  return (
    <section style={sectionStyle}>
      {/* Left Text Content */}
      <div style={leftStyle}>
        <h2 style={headingStyle}>
          About <span style={highlight}>Surgeazy</span>
        </h2>
        <p style={paragraphStyle}>
          At Surgeazy, we are revolutionizing the way patients connect with top healthcare providers. 
          Our mission is to bring quality medical care closer to everyone with seamless, smart, and secure online appointments.
        </p>

        <div style={pointsContainer}>
          <div style={point}>
            <div style={bullet}></div>
            Trusted network of certified doctors
          </div>
          <div style={point}>
            <div style={bullet}></div>
            Hassle-free appointment booking
          </div>
          <div style={point}>
            <div style={bullet}></div>
            Patient-first approach to healthcare
          </div>
          <div style={point}>
            <div style={bullet}></div>
            Secure digital medical records
          </div>
        </div>

        <button
          style={buttonStyle}
          onMouseEnter={(e) => (e.currentTarget.style.transform = "scale(1.05)")}
          onMouseLeave={(e) => (e.currentTarget.style.transform = "scale(1)")}
        >
          Learn More
        </button>
      </div>

      {/* Right Image Section */}
      <div style={rightStyle}>
        <div style={overlayCircle}></div>
        <img
          src="/assets/img/about/about.webp"
          alt="About Surgeazy"
          style={imageStyle}
          onMouseEnter={(e) => (e.currentTarget.style.transform = "scale(1.05)")}
          onMouseLeave={(e) => (e.currentTarget.style.transform = "scale(1)")}
        />
      </div>
    </section>
  );
};

export default Aboutus;
